
import { Component, Vue } from 'vue-property-decorator';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import { checkRole } from '@/modules/authentication/helpers/checkRole';
import QuickActions, { CardData } from '@/components/cta/QuickActions.vue';

@Component({
  components: { QuickActions }
})
export default class Merger extends Vue {
  protected cards: { data: CardData; to: unknown }[] = [];

  protected created(): void {
    if (checkRole(Roles.requests_create)) {
      this.cards.push({
        data: {
          title: this.$i18n.t('results.Merger.quickAction.interwinner.title').toString(),
          subtitle: this.$i18n.t('results.Merger.quickAction.interwinner.subtitle').toString(),
          icon: this.$i18n.t('results.Merger.quickAction.interwinner.icon').toString()
        },
        to: { name: 'Interwinner' }
      });
      this.cards.push({
        data: {
          title: this.$i18n.t('results.Merger.quickAction.g2000.title').toString(),
          subtitle: this.$i18n.t('results.Merger.quickAction.g2000.subtitle').toString(),
          icon: this.$i18n.t('results.Merger.quickAction.g2000.icon').toString()
        },
        to: { name: 'G2000' }
      });
    }
  }
}
